import { trpc } from "../lib/trpc";
import { Card, Badge, Spinner } from "../components/ui";
import { fmtDateLong } from "../lib/format";

const fmtDate = (d: string) => {
  // Parse the yyyy-mm-dd as Amsterdam midnight (the release dates are NL dates), then render in the same zone.
  const dt = new Date(`${d}T00:00:00`);
  return Number.isNaN(dt.getTime()) ? d : fmtDateLong(dt);
};

export default function Changelog() {
  const q = trpc.system.changelog.useQuery();
  return (
    <div className="mx-auto max-w-3xl space-y-5">
      <div>
        <h1 className="text-2xl font-semibold text-slate-900">Changelog</h1>
        <p className="mt-1 text-sm text-slate-500">What changed per version and when it went live.</p>
      </div>
      {q.isLoading ? (
        <Card><Spinner /></Card>
      ) : (
        <div className="space-y-3">
          {(q.data?.entries ?? []).map((e) => (
            <Card key={e.version}>
              <div className="flex flex-wrap items-center gap-2">
                <span className="font-mono text-sm font-semibold text-slate-900">v{e.version}</span>
                {q.data?.current === e.version && <Badge color="green">current version</Badge>}
                <span className="ml-auto text-xs text-slate-400">{fmtDate(e.date)}</span>
              </div>
              <ul className="mt-2 list-disc space-y-1 pl-5 text-sm text-slate-600">
                {e.summary.map((s, i) => <li key={i}>{s}</li>)}
              </ul>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
